<template>
  <div>
    <div
      class="modal-overlay"
      v-if="showModal"
      @click="!backdrop && overlayCloses && onCloseModal()"
    ></div>
    <div
      data-close="disabled"
      :class="{
        'sida-modal': true,
        'download-progress-modal': true,
        show: showModal,
        error
      }"
      :style="styles"
    >
      <h2 class="modal-title">{{ title }}</h2>
      <div class="modal-btn-close" v-if="!preventClose" @click="onCloseModal()">
        ×
      </div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      required: true
    },
    backdrop: {
      required: false
    },
    preventClose: {
      required: false
    },
    refreshPage: {
      required: false
    },
    value: {
      required: true
    },
    overlayCloses: {
      required: false,
      default: true
    },
    styles: {
      required: false,
      default: ""
    },
    error: {
      required: false
    }
  },
  data() {
    return {
      forceClose: false,
      showModal: false
    };
  },
  watch: {
    value: function(newVal, oldVal) {
      this.showModal = newVal;
      if (newVal) {
        document.querySelector("body").classList.add("modal-show");
      } else {
        document.querySelector("body").classList.remove("modal-show");
      }
    }
  },
  methods: {
    onCloseModal() {
      this.showModal = false;
      this.$emit("input", false);
      document.querySelector("body").classList.remove("modal-show");

      if (this.refreshPage) {
        window.location.reload(true); 
      }
    }
  },
  mounted() {
    if (this.value) {
      document.querySelector("body").classList.add("modal-show");
    }
    this.showModal = this.value;
  }
};
</script>

<style lang="scss" scoped>
.modal-overlay {
  background: rgba(0, 0, 0, 0.45);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 99;
}

.sida-modal {
  width: calc(100% - 20px);
  max-width: 700px;
  height: auto;
  background: #fff;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
  border-radius: 7px;
  display: none;
  flex-direction: column;

  /deep/ .modal-content {
    width: 100%;
    height: 350px;
    position: relative;
    transition: height 0.7s;
    display: inline-block;
    padding: 15px;
    overflow-y: auto;
    box-sizing: border-box;
  }

  /deep/ .modal-footer {
    background: #e1e1e1;
    width: 100%;
    padding: 3px;
    border-radius: 0 0 6px 6px;
  }

  &.show {
    display: flex;
  }

  &.loading {
    /deep/ .modal-content {
      height: 100px;

      & > * {
        display: none;
      }

      &::after {
        content: " ";
        width: 30px;
        height: 30px;
        border: 5px solid #393e3c;
        border-right-color: transparent;
        border-radius: 50%;
        position: absolute;
        top: calc(50% - 15px);
        left: calc(50% - 15px);
        animation: spin 1s linear infinite;
      }
    }
  }

  & > .modal-title {
    background: linear-gradient(to right, #204d37, #00853b 40%);
    color: #fff;
    font-weight: normal;
    text-align: center;
    font-size: 15px;
    padding: 10px;
    margin: 0;
    border-radius: 7px 7px 0 0;
  }

  .modal-btn-close {
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(50%, -50%);
    border: 2px solid #fff;
    border-radius: 50%;
    font-size: 18px;
    font-weight: bold;
    padding: 1px 3px;
    background: #000;
    color: #fff;
    line-height: 15px;
    cursor: pointer;
    outline: none;
  }

  &.error {
    .modal-title {
      background: linear-gradient(to right, #bb2727, #e20e0e 40%);
    }
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
